import React, { useMemo } from "react";
import { ICellRendererParams } from "ag-grid-community";
import classnames from "classnames";

type ClassnamesParameters = false | string | string[] | Record<string, any>;
export type InputRendererProps = {
    input: {
        dataTest?: string;
        classes?: ClassnamesParameters;
    };
    hint?: {
        value?: string | number;
        dataTest?: string;
        classes?: ClassnamesParameters;
    };
    value?: ICellRendererParams["value"]; // could be provided by ag-grid
};

export const InputRenderer = ({ input, hint, value, formatValue }: ICellRendererParams & InputRendererProps) => {
    const formattedValue = useMemo(() => (formatValue ? formatValue(value) : value), [value, formatValue]);
    return (
        <>
            <div className="quantity-wrap">
                <div className={classnames("quantity", input.classes)} data-test={input.dataTest}>
                    {formattedValue}
                </div>
            </div>
            {hint && (
                <div className={classnames("inventory", hint.classes)} data-test={hint.dataTest}>
                    {hint.value}
                </div>
            )}
        </>
    );
};
